import { GatsbyImage, GatsbyImageProps } from 'gatsby-plugin-image';
import { twMerge } from 'tailwind-merge';

import { ISanityImgWithAltText } from 'typescriptDefs';

type Props = {
  className?: string;
  icon: ISanityImgWithAltText;
} & Omit<GatsbyImageProps, 'image' | 'alt'>;

export const SanityIcon = ({ className, icon, ...imageProps }: Props) => {
  return (
    <GatsbyImage
      role="presentation"
      className={twMerge('h-32 w-32', className)}
      image={icon.img.asset.gatsbyImageData}
      alt={icon.altText}
      {...imageProps}
    />
  );
};
